import React from 'react';
import { tokenSelector } from '@redux/auth';
import { useSelector } from 'react-redux';
import noImage from '@img/no-image.png';
import './style.scss';

const StudyItem = ({
  image, title, authStudy, specialStudy, showAccessModal,
  showSpecialSurveyModal, showStudyModal, passed, isAffected,
}) => {
  const token = useSelector(tokenSelector);

  let lockedItem = (authStudy && !token) || (specialStudy && !isAffected);

  const onClick = () => {
    if (authStudy && !token) {
      showAccessModal();
    } else if (specialStudy && !isAffected) {
      showSpecialSurveyModal();
    } else {
      showStudyModal();
      lockedItem = false;
    }
  };

  let classNames = ['study-item', 'main-radius'];
  if (lockedItem) {
    classNames = [...classNames, 'study-item_locked'];
  } else if (passed) {
    classNames = [...classNames, 'study-item_passed'];
  }

  return (
    <div className={classNames.join(' ')} onClick={onClick}>
      <div className='study-item__img'>
        <img width={280} height={264} src={image || noImage} alt='study' />
      </div>
      <div className='study-item__title'>
        <span className='title-xs tablet-title-xs mobile-label-md'>{title}</span>
      </div>
    </div>
  );
};

export default StudyItem;
